import { getFinanceProfiles } from 'reduxpath/ducks/FinanceProfile/List'

import Home from 'units/FinanceProfile'
import List from 'units/FinanceProfile/units/List'

const list = (store) => {
  store.dispatch(
    getFinanceProfiles({
      sort: 'status ASC',
      limit: 10,
      skip: 0,
      where: {
        status: 0,
      },
    }),
  )
}

export default {
  populate: {
    list,
  },
  components: {
    Home,
    List,
  },
}
